// Маска телефона чекаута +7 (___) ___-__-__ (docs/07-miniapp-ux.md §2.5).
// Только форматирование ввода — формат окончательно проверяет бэкенд
// (order.NormalizePhone), сюда дублировать его правила незачем.

/** digitsOf — цифры номера без маски, ведущие 7/8 не входят. */
function digitsOf(raw: string): string {
  const digits = raw.replace(/\D/g, "");
  if (digits.startsWith("8") || digits.startsWith("7")) {
    return digits.slice(1, 11);
  }
  return digits.slice(0, 10);
}

/**
 * formatPhoneInput форматирует ввод по маске +7 (___) ___-__-__ по мере
 * набора. Незавершённый хвост остаётся коротким — маска не дорисовывает
 * плейсхолдеры за курсором.
 */
export function formatPhoneInput(raw: string): string {
  const digits = digitsOf(raw);
  if (digits.length === 0) {
    return "";
  }

  let result = "+7";
  if (digits.length > 0) result += ` (${digits.slice(0, 3)}`;
  if (digits.length >= 3) result += ")";
  if (digits.length > 3) result += ` ${digits.slice(3, 6)}`;
  if (digits.length > 6) result += `-${digits.slice(6, 8)}`;
  if (digits.length > 8) result += `-${digits.slice(8, 10)}`;
  return result;
}

/** isCompletePhone — набраны все 10 цифр номера после кода страны. */
export function isCompletePhone(raw: string): boolean {
  return digitsOf(raw).length === 10;
}

/** toE164 приводит номер к виду +7XXXXXXXXXX для отправки на сервер. */
export function toE164(raw: string): string {
  const digits = digitsOf(raw);
  return digits ? `+7${digits}` : "";
}

/**
 * maskPhone прячет середину номера для показа на экране успеха
 * (docs/07-miniapp-ux.md §2.6: «+7 999 ***-**-67»). Незавершённый номер
 * возвращается как есть — маскировать нечего.
 */
export function maskPhone(raw: string): string {
  const digits = digitsOf(raw);
  if (digits.length !== 10) {
    return raw;
  }
  return `+7 ${digits.slice(0, 3)} ***-**-${digits.slice(8, 10)}`;
}
